module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-studio-36d3f23456e39d071a0442c7bfc411d2.png";